<!--
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-05-10 14:39:15
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2026-03-31 00:00:00
 * @FilePath: /JTFE_home_user/src/App.vue
 * @Description: app entry
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<script setup lang="ts">
import en from 'element-plus/es/locale/lang/en';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

import { useLanguageStore } from '@/stores/languageStore.ts';
import Loading from '@/views/components/Loading.vue';
import { isLoading } from './router';

const languageStore = useLanguageStore();
const { currentLanguage } = storeToRefs(languageStore);
const elementLocale = computed(() => (currentLanguage.value === 'zh' ? zhCn : en));

const handleRouteChange = () => {
  isLoading.value = true;
};

const handleRouteEnd = () => {
  isLoading.value = false;
};

const checkAndRefreshPage = () => {
  const now = new Date();
  const targetHour = 8;
  const targetMinute = 30;
  if (now.getHours() === targetHour && now.getMinutes() === targetMinute) {
    window.location.reload();
  }
};

const intervalId = ref<number | null>(null);

onMounted(() => {
  intervalId.value = setInterval(() => {
    checkAndRefreshPage();
  }, 60000);
});

onBeforeUnmount(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = null;
  }
});
</script>

<template>
  <el-config-provider :locale="elementLocale">
    <Loading :isLoading="isLoading" />
    <RouterView v-slot="{ Component, route }">
      <component
        :is="Component"
        :key="route.fullPath"
        @routeChangeStart="handleRouteChange"
        @routeChangeEnd="handleRouteEnd"
      />
    </RouterView>
  </el-config-provider>
</template>
